import { requestGet as wsRequestGet, requestPost as wsRequestPost } from './_wsApiFetchData';

export async function getAvailabilityInfo(integrationId, language, timeZone, cancelToken) {
  return await wsRequestGet(`/admin/Integration/availability-info`, language, timeZone, { integrationId }, cancelToken);
}

export async function addAvailabilityInfo(integrationId, language, timeZone, cancelToken) {
  return await wsRequestPost(`/admin/Integration/add-availability-info`, language, timeZone, {}, { integrationId }, cancelToken);
}

export async function editAvailabilityInfo(data, language, timeZone, cancelToken) {
  return await wsRequestPost(`/admin/Integration/edit-availability-info`, language, timeZone, data, null, cancelToken);
}

export async function deleteAvailabilityInfo(integrationId, language, timeZone, cancelToken) {
  return await wsRequestGet(`/admin/Integration/delete-availability-info`, language, timeZone, {}, { integrationId }, cancelToken);
}

export async function saveIntegratedResource(productId, modelNew, language, timeZone, cancelToken) {
  modelNew.resourceGroupId = modelNew.resourceGroupId || undefined;
  return await wsRequestPost(`/admin/Integration/save-integrated-resource`, language, timeZone, modelNew, { productId }, cancelToken);
}

export async function getIntegratedResourcesStats(productId, language, timeZone, cancelToken) {
  return await wsRequestGet(`/admin/Integration/integrated-resources-stats`, language, timeZone, { productId }, cancelToken);
}

export async function reorderIntegratedResources(productId, orderedIds, language, timeZone, cancelToken) {
  return await wsRequestPost(`/admin/Integration/reorder-integrated-resources`, language, timeZone, orderedIds, { productId }, cancelToken);
}

export async function removeIntegratedResource(id, language, timeZone, cancelToken) {
  return await wsRequestGet(`/admin/Integration/remove-integrated-resource`, language, timeZone, { id }, cancelToken);
}

export async function getIntegratedResources(productId, language, timeZone, cancelToken) {
  return await wsRequestGet(`/admin/Integration/integrated-resources`, language, timeZone, { productId }, cancelToken);
}

// Admin helper for Bloo integrations: fetches the raw list of Bloo locations
// (locationRef + name + compartments) so the operator can pick the LocationId.
export async function getBlooLocations(language, timeZone, cancelToken) {
  return await wsRequestGet(`/admin/Integration/bloo-locations`, language, timeZone, null, cancelToken);
}

export async function searchIntegrations(options, language, timeZone, cancelToken) {
  const { filters, skipPages, resultsCount } = options;
  const {
    integrationId,
    productId,
    systemType,
    facilityId
  } = filters;

  const params = { 
    Page: skipPages || 1,
    Count: 15,
    Id: integrationId || undefined,
    ProductId: productId || undefined,
    SystemType: systemType || undefined,
    FacilityId: facilityId || undefined
  };

  return toPascal(await wsRequestGet('/admin/integration/search', language, timeZone, params, cancelToken));
}

export async function getIntegrationByProductId(
  id,
  language,
  timeZone,
  cancelToken
) {
  console.log('id=================', id);
  try {
    const integration = toPascal(await wsRequestGet(
      `/admin/integration/forproduct/${id}`,
      language,
      timeZone,
      null,
      cancelToken
    ));
    return integration;
  }
  catch (e) {
    return {
      DaysToCrawl: '',
      NextImportAt: '',
      SpotIndexMatch: '',
      SpotTitleMatch: '',
      SystemType: 'Undefined',
      TimeZone: '',
      Comment: '',
      ActivitySplitCount: '',
      Disables: [],
      Parameters: []
    };
  }
}

export async function getSystemTypeParameters(
  systemType,
  language,
  timeZone,
  cancelToken
) {
  return toPascal(await wsRequestGet(
    `/admin/integration/systems/parametertypes/${systemType}`,
    language,
    timeZone,
    null,
    cancelToken
  ));
}

export async function getSystemTypes(language, timeZone, cancelToken) {
  return toPascal(await wsRequestGet(
    '/admin/integration/systems/all',
    language,
    timeZone,
    null,
    cancelToken
  ));
}

export async function getIntegration(id, language, timeZone, cancelToken) {
  return toPascal(await wsRequestGet(
    `/admin/integration/get/${id}`,
    language,
    timeZone,
    null,
    cancelToken
  ));
}

export async function saveNewIntegration(
  {
    DaysToCrawl,
    NextImportAt,
    SystemType,
    SpotIndexMatch,
    SpotTitleMatch,
    TimeZone,
    Comment,
    ActivitySplitCount,
    Disables
  },
  ProductId,
  Parameters,
  language,
  timeZone,
  cancelToken
) {
  return toPascal(await wsRequestPost(
    '/admin/integration/create',
    language,
    timeZone,
    {
      ProductId,
      DaysToCrawl,
      NextImportAt,
      SystemType,
      SpotIndexMatch,
      SpotTitleMatch,
      TimeZone,
      Comment,
      ActivitySplitCount,
      Disables,
      Parameters
    },
    null,
    cancelToken
  ));
}

export async function editIntegrationData(
  {
    Id,
    DaysToCrawl,
    NextImportAt,
    SystemType,
    SpotIndexMatch,
    SpotTitleMatch,
    TimeZone,
    CreatedAt,
    Comment,
    ActivitySplitCount,
    Disables
  },
  ProductId,
  Parameters,
  language,
  timeZone,
  cancelToken
) {
  return toPascal(await wsRequestPost(
    '/admin/integration/edit',
    language,
    timeZone,
    {
      Id,
      DaysToCrawl,
      NextImportAt,
      SystemType,
      SpotIndexMatch,
      SpotTitleMatch,
      TimeZone,
      CreatedAt,
      Comment,
      ActivitySplitCount,
      ProductId,
      Disables,
      Parameters
    },
    null,
    cancelToken
  ));
}

export async function getRelay(id, language, timeZone, cancelToken) {
  return await wsRequestGet(`/admin/Integration/relay`, language, timeZone, { id }, cancelToken);
}

export async function updateRelay(relay, language, timeZone, cancelToken) {
  return await wsRequestPost(`/admin/Integration/relay-update`, language, timeZone, relay, null, cancelToken);
}

export async function getSchedules(integrationId, language, timeZone, cancelToken) {
  return await wsRequestGet(`/admin/Integration/schedule`, language, timeZone, { integrationId }, cancelToken);
}

export async function addSchedule(schedule, language, timeZone, cancelToken) {
  return await wsRequestPost(`/admin/Integration/schedulecreate`, language, timeZone, schedule, null, cancelToken);
}

export async function updateSchedule(schedule, language, timeZone, cancelToken) {
  return await wsRequestPost(`/admin/Integration/scheduleupdate`, language, timeZone, schedule, null, cancelToken);
}

export async function deleteSchedule(integrationId, scheduleId, language, timeZone, cancelToken) {
  return await wsRequestPost(`/admin/Integration/scheduleremove`, language, timeZone,{IntegrationId: integrationId, ScheduleId: scheduleId}, null, cancelToken);
}

export async function getCrawlFilters(integrationId, language, timeZone, cancelToken) {
  return await wsRequestGet(`/admin/Integration/crawl-filters`, language, timeZone, { integrationId }, cancelToken);
}

export async function addFilter(filter, language, timeZone, cancelToken) {
  let wsApiResult = await wsRequestPost(`/admin/Integration/add-filter`, language, timeZone, filter, null, cancelToken);

  return wsApiResult;
}

export async function editFilter(filter, language, timeZone, cancelToken) {
  let wsApiResult = await wsRequestPost(`/admin/Integration/edit-filter`, language, timeZone, filter, null, cancelToken);

  return wsApiResult;
}

export async function deleteFilter(filterId, language, timeZone, cancelToken) {
  let wsApiResult = await wsRequestGet(`/admin/Integration/delete-filter`, language, timeZone, {
    filterId: filterId
  }, cancelToken);

  return wsApiResult;
}

function toPascal(o) {
  var newO, origKey, newKey, value
  if (o instanceof Array) {
    return o.map(function(value) {
        if (typeof value === "object") {
          value = toPascal(value)
        }
        return value
    })
  } else {
    newO = {}
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = (origKey.charAt(0).toUpperCase() + origKey.slice(1) || origKey).toString()
        value = o[origKey]
        if (value instanceof Array || (value !== null && value.constructor === Object)) {
          value = toPascal(value)
        }
        newO[newKey] = value
      }
    }
  }
  return newO
}
